import { litController } from "../../utils/init";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import type { PropsWithChildren } from "react";

interface OTPVerificationParams {
  email: string | undefined,
  phoneNumber: string | undefined
  otp:string
  // code: string;
  // methodId: string;
  fromClientId?:string;
}

// interface initiateStytchAuth{
//   userId: string;
//   method: string;
//   fromClientId?:string;
// }

interface initiateOTP{
  email:string | undefined;
  phoneNumber:string | undefined;
  fromClientId?:string;
  origin:string
}
interface TriaAuthContext {
  initiateOTP(input: initiateOTP): Promise<any>;
  verifyOTP(params: OTPVerificationParams): Promise<any>;
}

const initialValue = {
  initiateOTP: () => Promise.reject(null),
  verifyOTP: () => Promise.reject(null),
};

const TriaAuthContext = createContext<TriaAuthContext>(initialValue);

export const useTriaAuth = () => useContext(TriaAuthContext);
console.log("authContoller",litController);

export function AuthProvider(props: PropsWithChildren) {
  const initiateOTP = useCallback(async (params: initiateOTP) => {
    try {
      const response = await (litController.signInWithOTP as any)(params);
      return response;
    } catch (error) {
      console.error(error);
      const { message } = error as Error;
      return Promise.reject(String(message || error));
    }
  }, []);


  const verifyOTP = useCallback(async (params: OTPVerificationParams) => {
    try {
      console.log("paramss",params);
      const response = await (litController.authenticateWithOTP as any)(params);

      return response;
    } catch (error) {
      console.error(error);
      const { message } = error as Error;
      return Promise.reject(String(message || error));
    }
  }, []);

  const value=useMemo(()=>({
    initiateOTP,
    verifyOTP
  }),[]
  );
  return <TriaAuthContext.Provider value={value}>{props.children}</TriaAuthContext.Provider>
}
